/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
// styles
import injectSheet from 'react-jss'
import styles from './articlesentiment_styles'
import EmojiPreview from 'material/emojipreview/emojipreview';

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW ~~~~~~~~~~ ========== */
const ArticleSentiment = injectSheet(styles)((props) => {

  const { } = props
  return (
    <div className={`articlesentiment ${props.classes.articlesentiment}`}>
      <Space direction={'column'}>
        <h4>Article Sentiment</h4>
        <hr />
      </Space>
       <EmojiPreview showPlaceholder />
    </div>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ArticleSentiment;
